export const eventMargin = 1;
export const minWeekEventWidth = 100 - eventMargin * 2;
export const eventMinLength = 0.5;
export const eventDefaultLength = 1;
export const DEFAULT_CALENDAR_HOUR_HEIGHT = 96;